export enum ButtonTypes {
  SUBMIT = 'submit_button',
  NAVIGATION = 'navigation_button',
  HREF = 'href_button',
  MODAL = 'modal_button',
  RELOAD = 'reload_button',
  BACK = 'back_button',
  ACTION = 'action_button',
}

export enum ButtonSizes {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}

export enum ButtonColors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERTIARY = 'tertiary',
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  TEXT = 'text',
}

export enum ButtonVariants {
  TEXT = 'text',
  OUTLINED = 'outlined',
  CONTAINED = 'contained',
}
